/*
  RESPONSIVE UTILITIES
*/

export function screenSize(check) {
    let mode = "==";
    if (check.indexOf(">=") == 0) mode = ">=";
    else if (check.indexOf(">") == 0) mode = ">";
    else if (check.indexOf("<=") == 0) mode = "<=";
    else if (check.indexOf("<") == 0) mode = "<";

    // TODO: Possibly unnecessary escape characters in Regex
    // eslint-disable-next-line no-useless-escape
    check = check.replace(/[&\/\\#,+()$~%.'":*?<>{}=]/g, "").toLowerCase();

    if (check === "xl") return test(5);
    if (check === "lg") return test(4);
    if (check === "md") return test(3);
    if (check === "sm") return test(2);
    if (check === "xs") return test(1);

    throw "WindowUtilities.screenSize: Invalid check!";

    function test(size) {
        if (mode === "==") return check === currentScreenSize();
        if (mode === ">=") return currentScreenSize(true) >= size;
        if (mode === ">") return currentScreenSize(true) > size;
        if (mode === "<=") return currentScreenSize(true) <= size;
        if (mode === "<") return currentScreenSize(true) < size;
    }
}

export function currentScreenSize(numeric = false) {
    if (document.body.offsetWidth >= 1200) return numeric ? 5 : "xl";
    if (document.body.offsetWidth >= 992) return numeric ? 4 : "lg";
    if (document.body.offsetWidth >= 768) return numeric ? 3 : "md";
    if (document.body.offsetWidth >= 576) return numeric ? 2 : "sm";
    return numeric ? 1 : "xs";
}


/*
  SCROLL UTILITIES
*/

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {
    37: 1,
    38: 1,
    39: 1,
    40: 1
};

function preventDefault(e) {
    e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, "passive", {
        // BUG: Get function with no return value
        // eslint-disable-next-line getter-return
        get: function () {
            supportsPassive = true;
        }
    }));
}
catch (e) {
    console.error(e)
}

var wheelOpt = supportsPassive ? {
    passive: false
} : false;
var wheelEvent = "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

// call this to Disable
export function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
}

// call this to Enable
export function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
}